import React, { FC } from "react"
import { Link, graphql } from "gatsby"

import { CardFragmentFragment, RelatedContentFragmentFragment } from "@graphqlTypes"

import Cards, { CARDS_VARIANTS } from "@components/Cards/Cards"

import {
  ContentRelatedContentDIV,
} from "./ContentRelatedContent.styles"

const ContentRelatedContent: FC<RelatedContentFragmentFragment> = ({
  posts,
  title = "Recommended Reading",
  isCondensed = false,
}) => (!posts || posts.length === 0) ? null : (
  <ContentRelatedContentDIV className={isCondensed ? "is-condensed" : ""}>
    {isCondensed ? (
      <p className="type--text-L">
        <span className="type--headline-medium-M">{title}:&nbsp;&nbsp;</span>
        {posts.map((post, i) => !post ? null : (
          <React.Fragment key={post.title}>
            <Link to={post.permalink || "/"}>{post.title}</Link>
            {`${i === posts.length - 1 ? "" : ", "}`}
          </React.Fragment>
        ))}
      </p>
    ) : (
      <>
        <h6>{title}</h6>
        <Cards
          items={posts as CardFragmentFragment[]}
          variant={CARDS_VARIANTS.COMPACT}
        />
      </>
    )}
  </ContentRelatedContentDIV>
)

export const RelatedContentFragment = graphql`
fragment RelatedContentFragment on ContentfulContentBlockRelatedContent {
  contentful_id
  entryTitle
  isCondensed
  posts: content {
    ...CardFragment
  }
  title
}
`

export default ContentRelatedContent
